import { useAuth } from "../../lib/auth/AuthContext";
import { Button } from "../../components/Button/Button";
import { InlineNotice } from "../../components/InlineNotice/InlineNotice";
import { IconStore } from "../../components/icons/icons";
import styles from "./SignInView.module.css";

export function SignInView() {
  const { signIn, authError, dismissAuthError, flash } = useAuth();

  return (
    <div className={styles.page}>
      <div className={styles.card}>
        <span className={styles.mark}>
          <IconStore width={24} height={24} />
        </span>
        <h1 className={styles.heading}>Sign in</h1>
        <p className={styles.body}>
          Business owners and administrators sign in here to manage their workspace — share a signup link
          and watch who joins, or launch new businesses and assign their owners.
        </p>
        {flash && <InlineNotice tone="info">{flash}</InlineNotice>}
        {authError && (
          <InlineNotice tone="error" onDismiss={dismissAuthError}>
            {authError}
          </InlineNotice>
        )}
        <div className={styles.actions}>
          <Button fullWidth onClick={() => void signIn()}>
            Sign in
          </Button>
        </div>
        <p className={styles.altAction}>
          New here?{" "}
          <button type="button" onClick={() => void signIn({ screenHint: "signup" })}>
            Create an account
          </button>{" "}
          and ask an administrator to assign you to a business.
        </p>
      </div>
    </div>
  );
}
